export default "__VITE_ASSET__jj43AuKu__"